var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grade-graphic",class:{
    passed: _vm.passed,
  }},[(_vm.isPicture)?_c('img',{staticClass:"grade-picture",attrs:{"src":_vm.pictureUrl,"alt":_vm.grade.name}}):_c('p',{staticClass:"grade-text",class:{ 'long-string': _vm.longString, 'short-string': _vm.shortString }},[_vm._v(" "+_vm._s(_vm.grade.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }